{
    "name": "@netwealth/web-components",
    "version": "21.0.26",
    "main": "bundle.js"
}
